import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from '../../common-class/survey';
declare var $: any;

@Component({
  selector: 'app-media-control',
  templateUrl: './media-control.component.html',
  styleUrls: ['./media-control.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaControlComponent implements OnInit {

  @Input() mediaName: string;
  @Input() mediaUrl: string;
  @Input() mediaEmbed: string = "";
  @Input() isLoadFile: boolean;
  @Input() isQuestionMedia: boolean = false;
  @Input() mediaCaption:string;
  @Input() isAnsMedia: boolean = false;
  path: string = "";
  productName: string = '';
  MediaAlt:string='';
  isPlayMedia: boolean;
  isVideoFile: boolean;
  isDownloadFile: boolean;
  isOfflineSurvey: boolean = false;
  idKey: string;

  constructor(private service:ParticipationDataService, private changeDetect: ChangeDetectorRef,private offlineSurvey: OfflineSurvey) {
    if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
      this.isOfflineSurvey=this.offlineSurvey.isOfflineSurvey;
    }
   }

  ngOnInit() {
    this.idKey = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
    this.path = this.service.getBasePath() +"/"+ this.service.getImageFolder();
    this.MediaAlt = this.mediaCaption != undefined && this.mediaCaption != "" ? this.mediaCaption : "graphics";
    this.productName = this.service.getProductName();

    if (this.mediaEmbed == null) {
      if (this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "wav" ||
        this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mp3" ||
        this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "wma") {
        this.isVideoFile = false;

        if (this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "wma") {
          this.isDownloadFile = true;
        } else if (/msie\s|trident\//i.test(window.navigator.userAgent) &&
          this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "wav") {
          this.isDownloadFile = true;
        }
        else {
          this.isDownloadFile = false;
        }
      } else {
        this.isVideoFile = true;

        if (this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mov" ||
          this.mediaName.substr((this.mediaName.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mp4") {
          this.isDownloadFile = false;
        } else {
          this.isDownloadFile = true;
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.mediaEmbed != null) {      
      var iframeEle = $('#' + this.idKey + '_embed').find('iframe');

      if (iframeEle != undefined && $(iframeEle).parents().hasClass('one-image')) {
        let height = iframeEle.attr('height');

        if (height == undefined || height == "") {
          $('#' + this.idKey + '_embed').find('iframe').css("width", '100%');
          let width = $('#' + this.idKey + '_embed').find('iframe').width();
          $('#' + this.idKey + '_embed').find('iframe').css("height", width);
        }
      }
    }
  }  

  isAnswerMedia(): boolean {
    return this.isAnsMedia;
  }

  playMedia(isPlay: boolean) {
    if (isPlay) {
      this.isPlayMedia = true;
    } else {
      this.isPlayMedia = false;
    }
    this.changeDetect.detectChanges();
  }

  isPlayedFile(url: string): boolean {
    if (url.substr((url.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mp3" ||
      url.substr((url.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mov" ||
      url.substr((url.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mp4") {
      return true;
    } else {
      return false;
    }
  }

  isAudioFile(url: string): boolean {
    if (url.substr((url.lastIndexOf('.') + 1)).toLocaleLowerCase() == "mp3") {
      return true;
    } else {
      return false;
    }
  }

  onFullScreen(e) {
    var isFullscreenNow = document.fullscreenElement !== null
    if (!isFullscreenNow) {
     // $('html, body').animate({ scrollTop: $('#' + this.idKey + '_video').offset().top }, 1000);
      $(window).scrollTop($('#' + this.idKey + '_video').offset().top);
    }
  }
}
